"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslations = exports.getTextByLanguage = exports.detectDeviceLocale = void 0;
exports.isObject = isObject;
exports.isTransArrayFunction = isTransArrayFunction;
exports.isTranslation = isTranslation;
exports.isVariableFunction = isVariableFunction;
exports.validateLocale = exports.tryParseLocale = exports.reportMissing = exports.lookForMissingKeys = exports.localePattern = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.reduce.js");
var _constants = require("../../utils/constants");
var _functions = require("../../utils/functions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const localePattern = exports.localePattern = /[a-z]{2}-[A-Z]{2}/gi;
const validateLocale = (locale, pattern) => {
  const activePattern = pattern || localePattern;
  return Boolean(new RegExp(activePattern).test(locale));
};

/**
 * Detects the preferred locale and parses it.
 * @returns Detected browser locale or null.
 */
exports.validateLocale = validateLocale;
const detectDeviceLocale = () => {
  var _window, _window2;
  let browserLocale = (0, _functions.getFromLocalStorage)('locale') || null;
  const hasLanguageInList = locale => _constants.locales.find(lang => lang.slice(0, 2) === (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)));
  if (browserLocale && hasLanguageInList(browserLocale)) return browserLocale;
  if ((_window = window) !== null && _window !== void 0 && (_window = _window.navigator) !== null && _window !== void 0 && _window.language) browserLocale = tryParseLocale(window.navigator.language);else if (((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 || (_window2 = _window2.languages) === null || _window2 === void 0 ? void 0 : _window2.length) > 0) browserLocale = tryParseLocale(window.navigator.languages[0]);
  if (!browserLocale) console.warn('Littera could not determine the preferred locale.');
  if (!hasLanguageInList(browserLocale)) return _constants.defaultLocale;
  return browserLocale || null;
};

/**
 * Tries parsing locale from a string. (eg. de-DE or de => de-DE)
 * @param locale Locale string. (eg. de)
 * @returns Parsed locale string or null. (eg. de-DE)
 */
/** @todo Refactor with early-return */
exports.detectDeviceLocale = detectDeviceLocale;
const tryParseLocale = locale => {
  if (!locale) return null;
  if (locale.length === 2) {
    if (locale === 'en') return 'en-US';
    return "".concat(locale, "_").concat(locale.toUpperCase());
  }
  if (locale.length === 5) {
    if (locale.includes('_')) return locale.replace(/_/g, '-');else if (locale.includes('-')) return locale;
  }
  return null;
};

/**
 * Searches for missing translations. Prints an warning if there is a translation for a language missing.
 * @param translations
 * @param locales List of country codes for tested languages. eg. ["de-DE", "pl_PL"]
 */
/** @todo Refactor with early-return */
exports.tryParseLocale = tryParseLocale;
const reportMissing = exports.reportMissing = function reportMissing() {
  let translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let locales = arguments.length > 1 ? arguments[1] : undefined;
  if ((0, _functions.getFromLocalStorage)('_SHOW_LOCALISATION_LOGS')) Object.keys(translations).forEach(key => {
    if (typeof translations[key] === 'function') return; // TODO: Detect missing translations for variable functions.
    if (translations[key] instanceof Array) return; // TODO: Detect missing translations for arrays.

    locales.forEach(locale => {
      if (translations[key] && typeof translations[key][locale] !== 'string') console.log("LOCALISATION::\"".concat(key, "\" is missing in ").concat(locale, "."));
    });
  });
};

/**
 * Searches for missing translations. Prints an warning if there is a translation for a language missing.
 * @param translations
 * @param locales List of country codes for tested languages. eg. ["de-DE", "pl_PL"]
 * @deprecated Naming changed to reportMissing.
 * @augments reportMissing
 */
const lookForMissingKeys = exports.lookForMissingKeys = reportMissing;

/**
 * Checks if value is a object.
 * @param value
 * @returns
 */
function isObject(value) {
  return typeof value === 'object';
}

/**
 * Checks if value is a translation object.
 * @param value
 * @param {[string]} locales
 * @returns
 */
function isTranslation(value, locales) {
  return isObject(value) && (Object.keys(value).some(key => locales.includes(key)) || Object.values(value).some(value => !isObject(value)));
}

/**
 * Checks if value is a variable function.
 * @param value
 * @returns
 */
function isVariableFunction(value) {
  return typeof value === 'function';
}

/**
 * Checks if value is a translations array.
 * @param value
 * @returns
 */
function isTransArrayFunction(value) {
  return value instanceof Array && !value.find(v => !isObject(v));
}

/**
 * Attempting to parse localised text from a value. (eg. {'de-DE': 'text'} or text => text)
 * @param {any} text Locale string. (eg. de).
 * @param {object} params Object with settings.
 * @param {string = ''} params.defaultText Default text when text is empty.
 * @param {string = defaultLocale } params.activeLanguage Active language (eg. de-DE).
 * @param {string = defaultLocale} params.defaultLanguage Default language (eg. de-DE).
 *
 * @returns Parsed localised text or default text.
 */
const getTextByLanguage = exports.getTextByLanguage = function getTextByLanguage(text) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    defaultText = '',
    activeLanguage = _constants.defaultLocale,
    defaultLanguage = _constants.defaultLocale
  } = params;
  switch (typeof text) {
    case 'object':
      return text ? text[activeLanguage] || text[defaultLanguage] || Object.values(text)[0] || defaultText : defaultText;
    case 'string':
      return text;
    default:
      return !Array.isArray(text) ? text : defaultText;
  }
};
/**
 * @method setTranslations
 *
 * @param {object} translations Translations
 * @param {string} locale Locale
 * @param {[string]} locales Locales
 *
 * @return {object} Active translations
 */
const getTranslations = exports.getTranslations = function getTranslations() {
  let translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let locale = arguments.length > 1 ? arguments[1] : undefined;
  let locales = arguments.length > 2 ? arguments[2] : undefined;
  const getTranslate = itemTranslations => isTranslation(itemTranslations, locales) ? getTextByLanguage(itemTranslations, {
    activeLanguage: locale
  }) : Object.keys(itemTranslations).reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
    [key]: getTranslate(itemTranslations[key])
  }), {});
  return getTranslate(translations);
};